module.exports = __webpack_public_path__ + "static/media/disc_C.15c302e0.png";